import { render, staticRenderFns } from "./Eventbrite.vue?vue&type=template&id=aa651612"
import script from "./Eventbrite.vue?vue&type=script&lang=js"
export * from "./Eventbrite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports